interface Shift {
  startHour: number;
  endHour: number;
}

interface CustomerShift {
  originalOffsetMinutes: number; // original UTC offset at the time the shift table was created
  timeZone: string;
  shifts: Shift[];
}

export const CustomerShiftsDetails: Record<string, CustomerShift> = {
  mop: {
    originalOffsetMinutes: 120, // Africa/Lusaka UTC+2
    timeZone: "Africa/Lusaka'",
    shifts: [
      { startHour: 4, endHour: 16 },
      { startHour: 16, endHour: 28 },
    ],
  },
  buz: {
    originalOffsetMinutes: -300, // America/Chicago UTC-5 (DST at creation)
    timeZone: 'America/Chicago',
    shifts: [{ startHour: 10, endHour: 21 }],
  },
  myn: {
    originalOffsetMinutes: -300, // America/Chicago UTC-5 (DST at creation)
    timeZone: 'America/Chicago',
    shifts: [{ startHour: 10, endHour: 21 }],
  },
  drn: {
    originalOffsetMinutes: -300, // America/Chicago UTC-5 (DST at creation)
    timeZone: 'America/Chicago',
    shifts: [
      { startHour: 11, endHour: 23 },
      { startHour: 23, endHour: 35 },
    ],
  },
  // below are kept since we don't know exact timings for shifts for gdy, lhl, sav [subject to change]
  lhl: {
    originalOffsetMinutes: -300, // America/New York UTC-5 (DST at creation)
    timeZone: 'America/New_York',
    shifts: [{ startHour: 10, endHour: 21 }],
  },
  sav: {
    originalOffsetMinutes: -300, // America/New York UTC-5 (DST at creation)
    timeZone: 'America/New_York',
    shifts: [{ startHour: 10, endHour: 21 }],
  },
  gdy: {
    originalOffsetMinutes: -420, // America/New York UTC-7 (DST at creation)
    timeZone: 'America/New_York',
    shifts: [{ startHour: 10, endHour: 21 }],
  },
  others: {
    originalOffsetMinutes: 0, // GMT
    timeZone: 'Etc/GMT',
    shifts: [{ startHour: 0, endHour: 20 }],
  },
};
